/* ----- COMPONENT TEST DATA ---- 
    1. Make sure to change "template" to your actual component name
*/
import { mlsComplianceData as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  name: 'MLS Name',
  resoId: 'RESO ID',
  disclaimer: 'Disclaimer',
};

export default fakeProps(schema, TestData);
